import { useState } from 'react';
import { TabsUI, FileTabUI, DeleteDialogUI, FormLabelUI, FormErrorUI, InputUI } from '../Interface';

import DynamicPropertyMain from '../DynamicProperty/DynamicPropertyMain';
import { Field, useFormikContext } from 'formik';
import { Box } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import Comments from '../Comment/Comments';

const DescriptionPanel = (props) => {
  const { disabled } = props;
  const { values, errors } = useFormikContext();
  return (
    <div className="col-span-full relative">
      <Box>
        <Field
          type="text"
          name="description"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Részletes leírás" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.description} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.description && values.description !== '' }}
          multiline
          rows={4}
        />
      </Box>
      <Box mt="1rem">
        <Field
          type="text"
          name="solutionProposal"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Megoldási javaslat" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.solutionProposal} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.solutionProposal && values.solutionProposal !== '' }}
          multiline
          rows={4}
        />
      </Box>
    </div>
  );
};

const TaskFeedbackTabs = (props) => {
  const { setFieldValue, values } = useFormikContext();
  const { disabled, selectedValues, addField, setRefetchTable, dialog } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [deleteDialog, setDeletDialog] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);

  const handleUpload = (files) => {
    const filesWithId = files.map((file) => {
      file.id = uuidv4();
      return file;
    });

    const existingAttachments = Array.isArray(values.taskFeedbackAttachment) ? values.taskFeedbackAttachment : [];

    setFieldValue('taskFeedbackAttachment', [...existingAttachments, ...filesWithId]);
  };

  const handleRemoveElement = () => {
    setFieldValue(
      'taskFeedbackAttachment',
      (values.taskFeedbackAttachment || []).filter(
        (taskFeedbackAttachment) => taskFeedbackAttachment.id !== fileToDelete.id
      )
    );

    setFileToDelete(null);
    hideDeleteDialog();
  };

  const tabs = [
    {
      id: 0,
      name: 'Leírás',
      content: <DescriptionPanel {...props} />,
    },
    {
      id: 1,
      name: 'Tulajdonságok',
      content: <DynamicPropertyMain {...props} />,
    },
    {
      id: 2,
      name: 'Csatolmányok',
      content: (
        <FileTabUI
          disabled={disabled}
          handleUpload={handleUpload}
          handleDelete={(file) => {
            setFileToDelete(file);
            setDeletDialog(true);
          }}
          savedFiles={values.taskFeedbackAttachment ?? []}
        />
      ),
    },
    {
      id: 3,
      name: 'Hozzászólások',
      content: (
        <Comments
          rows={selectedValues.comments ?? []}
          lineId={selectedValues.id}
          subMenuUrl="taskFeedback"
          setRefetchTable={dialog ? dialog?.setTaskChanged : setRefetchTable}
          disabled={disabled || !addField}
        />
      ),
    },
  ];

  const hideDeleteDialog = () => {
    setDeletDialog(false);
  };

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={deleteDialog}
        onHide={() => {
          hideDeleteDialog();
          setFileToDelete(null);
        }}
      />
    </div>
  );
};

export default TaskFeedbackTabs;
